import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Paragraph: FC<TextProps> = props => (
  <Text
    fontSize="body"
    {...props}
    className={classNames(props.className, 'text_paragraph')}
  />
);

export default Paragraph;
